"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.synthesizeDataWithJSONSchema = void 0;
var seedrandom_1 = __importDefault(require("seedrandom"));
var synthesizeValue_1 = require("./synthesize/synthesizeValue");
var hash_1 = require("./util/hash");
function synthesizeDataWithJSONSchema(schema) {
    var seed = typeof schema === 'object' ? (0, hash_1.hash)(schema) : "".concat(schema);
    var random = (0, seedrandom_1["default"])(seed);
    return (0, synthesizeValue_1.synthesizeValue)(schema, { random: random });
}
exports.synthesizeDataWithJSONSchema = synthesizeDataWithJSONSchema;
